import { render } from "./ClienteModal.vue?vue&type=template&id=2cfd56c8"
import script from "./ClienteModal.vue?vue&type=script&lang=js"
export * from "./ClienteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__